// This lets the app load faster on subsequent visits in production, and gives it offline capabilities.
// Also proivdes a way to display the 'New vesrsion avaliable' message

import { isMobileApp } from '@utils/screenUtils';

const { hostname } = window.location;
const isLocalhost = Boolean(
  hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

//TODO fix this if possible
// during testing i've recieved unexpected token '<' error
//probably this caused it:
// *.chunk.js file is cached before it is available
//so some 404 html is returned from CF and js fires syntax error since it can't parse html as js
//so this hopefully fixes malfunctioned cache :)
window.addEventListener('error', function(event) {
  const string = event.message.toLowerCase();
  const substring = "unexpected token '<'";
  if (string.indexOf(substring) > -1) {
    caches
      .keys()
      .then(function(cacheNames) {
        return Promise.all(
          cacheNames.map(function(cacheName) {
            return caches.delete(cacheName);
          })
        );
      })
      .then(() => window.location.reload());
    return true;
  }
  return false;
});

export function register({ dispatch }: { dispatch: (payload: any) => any }) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, dispatch);
        // Add some additional logging to localhost, pointing developers to the
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'This web app is being served cache-first by a service worker. To learn more, visit https://cra.link/PWA'
          );
        });
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, dispatch);
      }
    });
  }
}

function registerValidSW(swUrl: string, dispatch: (payoad: any) => any) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      //chek for new SW every hour
      setInterval(() => {
        try {
          registration?.update();
        } catch (e) {}
      }, 1000 * 60 * 60);
      registration.onupdatefound = () => {
        caches.keys().then(function(cacheNames) {
          return Promise.all(
            cacheNames.map(function(cacheName) {
              return caches.delete(cacheName);
            })
          );
        });
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (!registration.active && registration.waiting) {
            //this is the case when this is the first version of this SW so nothing needs to be done
            dispatch({
              type: 'SW',
              payload: {
                firstTime: true,
                newVersionAvailable: null,
                updateDone: null
              }
            });
            return;
          }
          if (installingWorker.state == 'installed') {
            //after SW's state is changed to installed, it either stays there (if it's waithing) or goes to activating
            //so we puth this check into evnet loop <=> after SW changes it's state
            setTimeout(() => {
              //check new state:
              //if it is still installed, that means that SW's in waiting phase => dislay new version dialog
              if (installingWorker.state == 'installed') {
                dispatch({
                  type: 'SW',
                  payload: {
                    firstTime: false,
                    newVersionAvailable: true,
                    updateDone: false,
                    registration
                  }
                });
              } else {
                dispatch({
                  type: 'SW',
                  payload: {
                    firstTime: false,
                    newVersionAvailable: true,
                    updateDone: true
                  }
                });
              }
            }, 4000);
          }
        };
      };
    })
    .catch(error => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl: string, dispatch: (payoad: any) => any) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' }
  })
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (response.status === 404 || (contentType != null && contentType.indexOf('javascript') === -1)) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            console.log('We are in local mode');
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, dispatch);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error(error.message);
      });
  }
}

// reload ONCE when the new SW starts activating
if (!isMobileApp) {
  let refreshing = false;
  // If nothing was controlling this page yet, this controllerchange is the SW claiming a
  // page it just loaded (e.g. first-ever visit) rather than a new version replacing an old
  // one — the page is already fresh, so reloading here just interrupts the user for nothing.
  let hadController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener('controllerchange', function() {
    if (!hadController) {
      hadController = true;
      return;
    }
    if (refreshing) {
      return;
    }
    refreshing = true;
    window.location.reload();
  });
}
